var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.dialogs),function(dialog,index){return _c('div',{key:index},[_c(dialog.component,{tag:"component",attrs:{"dialog":dialog}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }